"use strict";

define('view/achievement',['underscore', 'marionette', 'semantic/modules/transition', 'jquery-easing'], function (_, Mn) {
  var AchievementView = Mn.ItemView.extend({
    modelEvents: {
      'will:remove': function willRemove() {
        this.$el.transition('horizontal flip');
      }
    },
    attributes: {
      style: 'width: 300px; display: none'
    },
    className: 'ui compact icon yellow message',
    template: function template(data) {
      var icon = data.icon || 'trophy';
      return '<i class="' + icon + ' icon"></i>' + '<div class="content">' + '<div class="header">' + data.header + '</div>' + '<p>' + data.body + '</p>';
      '</div>';
    },
    onShow: function onShow() {
      var self = this;
      _.defer(function () {
        self.$el.transition('fly');
      });
    }
  });
});

